import { FILE_SIZE_EXCEEDS_LIMIT } from '@/shared/config';

export const CERTIFICATE_ALLOWED_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png'] as const;

export const CERTIFICATE_ACCEPT_ATTRIBUTE = CERTIFICATE_ALLOWED_EXTENSIONS.join(',');

export const CERTIFICATE_ALLOWED_FORMATS_LABEL = 'PDF, JPG, JPEG e PNG';

export const CERTIFICATE_MAX_FILE_SIZE_MB = 50;

export const CERTIFICATE_MAX_FILE_SIZE_BYTES = CERTIFICATE_MAX_FILE_SIZE_MB * 1024 * 1024;

export const CERTIFICATE_MAX_FILE_SIZE_LABEL = '50MB';

export const CERTIFICATE_FORMAT_ERROR_MESSAGE = `Arquivo enviado com o formato incorreto. São aceitos os formatos: ${CERTIFICATE_ALLOWED_FORMATS_LABEL}.`;

export const CERTIFICATE_SIZE_ERROR_MESSAGE = FILE_SIZE_EXCEEDS_LIMIT(CERTIFICATE_MAX_FILE_SIZE_MB);

export function validateCertificateFile(file: File): string | null {
  const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

  if (!file.name.includes('.') || !CERTIFICATE_ALLOWED_EXTENSIONS.includes(extension as never)) {
    return CERTIFICATE_FORMAT_ERROR_MESSAGE;
  }

  if (file.size > CERTIFICATE_MAX_FILE_SIZE_BYTES) {
    return CERTIFICATE_SIZE_ERROR_MESSAGE;
  }

  return null;
}
